import {parseIdentityStatus,parseParticipant,parseSafetyStatus,parseSpaces} from './contracts';
import {edgeRequest} from './supabaseGateway';
import type {IdentityStatus,Participant,SafetyStatus,Space} from './types';

function record(value:unknown):Record<string,unknown>|null{
 return value&&typeof value==='object'&&!Array.isArray(value)?value as Record<string,unknown>:null;
}

function request<T>(functionName:string,path=''):Promise<T>{
 return edgeRequest<T>(functionName,path,{
  fallbackMessage:'Der geschützte Bereich konnte nicht geladen werden.',
  networkMessage:'Die Verbindung zu deinen Räumen konnte nicht hergestellt werden. Bitte lade die Seite neu.',
 });
}

export async function loadIdentityStatus():Promise<IdentityStatus>{
 return parseIdentityStatus(await request<unknown>('community-identity-status'));
}
export async function loadParticipant():Promise<Participant>{
 const data=await request<{participant:unknown}>('summer-intensive-auth','/me');
 const legacy=record(data.participant);
 if(typeof legacy?.id==='string'&&legacy.id.trim())return parseParticipant(legacy);
 const identity=await loadIdentityStatus();
 return parseParticipant({
  id:identity.participant.id,
  name:typeof legacy?.name==='string'?legacy.name:identity.participant.name,
  email:typeof legacy?.email==='string'?legacy.email:identity.participant.email,
  role:typeof legacy?.role==='string'?legacy.role:identity.participant.global_role,
 });
}
export async function loadSpaces():Promise<Space[]>{
 const data=await request<{spaces:unknown}>('community-platform','/bootstrap');
 if(!Array.isArray(data.spaces))throw new Error('Die Raumliste konnte nicht gelesen werden. Bitte lade die Community neu.');
 return parseSpaces(data.spaces);
}
export async function loadSafetyStatus():Promise<SafetyStatus>{
 return parseSafetyStatus(await request<unknown>('community-legacy-safety','/status'));
}
